"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testStore = void 0;
const vector_types_1 = require("@connext/vector-types");
const constants_1 = require("@ethersproject/constants");
const _1 = require(".");
const testStore = (name, makeStore, isBrowserStore = false) => {
    describe(name, () => {
        let store;
        before(() => __awaiter(void 0, void 0, void 0, function* () {
            store = makeStore();
        }));
        beforeEach(() => __awaiter(void 0, void 0, void 0, function* () {
            yield store.clear();
        }));
        after(() => __awaiter(void 0, void 0, void 0, function* () {
            yield store.disconnect();
        }));
        describe("saveChannelStateAndTransfers", () => {
            it("saveChannelStateAndTransfers removes previous state", () => __awaiter(void 0, void 0, void 0, function* () {
                const { channel, transfer } = _1.createTestChannelState("create", { nonce: 10 }, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                yield store.saveChannelState(channel, transfer);
                const fromStore = yield store.getChannelState(channel.channelAddress);
                _1.expect(fromStore).to.deep.eq(channel);
                const { channel: newChannel, transfer: newTransfer } = _1.createTestChannelState("create", { nonce: 9 }, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                yield store.saveChannelStateAndTransfers(newChannel, [newTransfer]);
                const afterRestore = yield store.getChannelState(channel.channelAddress);
                _1.expect(afterRestore).to.deep.eq(newChannel);
            }));
            it("saveChannelStateAndTransfers should work when provided with transfers", () => __awaiter(void 0, void 0, void 0, function* () {
                const { channel, transfer } = _1.createTestChannelState("create", {}, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                const starting = transfer.channelNonce;
                const transfers = Array(5)
                    .fill(0)
                    .map((_, idx) => {
                    return Object.assign(Object.assign({}, transfer), { transferId: _1.getRandomBytes32(), channelNonce: starting + idx, meta: { routingId: _1.getRandomBytes32() } });
                });
                yield store.saveChannelStateAndTransfers(channel, transfers);
                const retrieved = yield store.getChannelState(channel.channelAddress);
                _1.expect(retrieved).to.be.deep.eq(channel);
                for (const t of transfers) {
                    const retrieved = yield store.getTransferState(t.transferId);
                    _1.expect(retrieved).to.be.deep.eq(t);
                }
                _1.expect((yield store.getActiveTransfers(channel.channelAddress)).sort((a, b) => a.channelNonce - b.channelNonce)).to.be.deep.eq(transfers.sort((a, b) => a.channelNonce - b.channelNonce));
                const secondChannel = Object.assign(Object.assign({}, channel), { nonce: 30 });
                const secondTransfers = transfers
                    .map((t, idx) => {
                    return Object.assign(Object.assign({}, t), { channelNonce: 30 + idx, meta: { routingId: _1.getRandomBytes32() } });
                })
                    .slice(0, 3);
                yield store.saveChannelStateAndTransfers(secondChannel, secondTransfers);
                const retrieved2 = yield store.getChannelState(secondChannel.channelAddress);
                _1.expect(retrieved2).to.be.deep.eq(secondChannel);
                for (const t2 of secondTransfers) {
                    const retrieved = yield store.getTransferState(t2.transferId);
                    _1.expect(retrieved).to.be.deep.eq(t2);
                }
                _1.expect((yield store.getActiveTransfers(secondChannel.channelAddress)).sort((a, b) => a.channelNonce - b.channelNonce)).to.be.deep.eq(secondTransfers.sort((a, b) => a.channelNonce - b.channelNonce));
            }));
            it("saveChannelStateAndTransfers should work when provided with no active transfers", () => __awaiter(void 0, void 0, void 0, function* () {
                const { channel } = _1.createTestChannelState("create", undefined, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                yield store.saveChannelStateAndTransfers(channel, []);
                const retrieved = yield store.getChannelState(channel.channelAddress);
                _1.expect(retrieved).to.be.deep.eq(channel);
            }));
        });
        describe("getActiveTransfers", () => {
            it("should get active transfers for different channels", () => __awaiter(void 0, void 0, void 0, function* () {
                const channel1 = _1.mkAddress("0xaaa");
                const transfer1State = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                }, { transferId: _1.mkHash("0x123"), meta: { routingId: _1.mkHash("0x123") } });
                yield store.saveChannelState(transfer1State.channel, transfer1State.transfer);
                const transfer2State = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                    nonce: transfer1State.channel.nonce + 1,
                }, { transferId: _1.mkHash("0x456"), meta: { routingId: _1.mkHash("0x456") } });
                yield store.saveChannelState(transfer2State.channel, transfer2State.transfer);
                const channel2 = _1.mkAddress("0xbbb");
                const transfer3State = _1.createTestChannelState("create", {
                    channelAddress: channel2,
                    bob: _1.mkAddress("0xbaba"),
                    bobIdentifier: _1.mkPublicIdentifier("vectorABCD"),
                }, { transferId: _1.mkHash("0x789"), meta: { routingId: _1.mkHash("0x789") } });
                yield store.saveChannelState(transfer3State.channel, transfer3State.transfer);
                const channelFromStore = yield store.getChannelState(transfer1State.channel.channelAddress);
                _1.expect(channelFromStore).to.deep.eq(transfer2State.channel);
                const transfersChannel1 = yield store.getActiveTransfers(transfer1State.channel.channelAddress);
                _1.expect(transfersChannel1.length).eq(2);
                const t1 = transfersChannel1.find((t) => t.transferId === transfer1State.transfer.transferId);
                const t2 = transfersChannel1.find((t) => t.transferId === transfer2State.transfer.transferId);
                _1.expect(t1).to.deep.eq(transfer1State.transfer);
                _1.expect(t2).to.deep.eq(transfer2State.transfer);
                const transfersChannel2 = yield store.getActiveTransfers(transfer3State.channel.channelAddress);
                const t3 = transfersChannel2.find((t) => t.transferId === transfer3State.transfer.transferId);
                _1.expect(t3).to.deep.eq(transfer3State.transfer);
            }));
            it("should consider resolved transfers", () => __awaiter(void 0, void 0, void 0, function* () {
                const channel1 = _1.mkAddress("0xaaa");
                const transfer1State = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                }, { transferId: _1.mkHash("0x123"), meta: { routingId: _1.mkHash("0x123") } });
                yield store.saveChannelState(transfer1State.channel, transfer1State.transfer);
                const transfer2Create = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                    nonce: transfer1State.channel.nonce + 1,
                }, { transferId: _1.mkHash("0x456"), meta: { routingId: _1.mkHash("0x456") } });
                yield store.saveChannelState(transfer2Create.channel, transfer2Create.transfer);
                const transfer2Resolve = _1.createTestChannelState("resolve", {
                    channelAddress: channel1,
                    nonce: transfer2Create.channel.nonce + 1,
                }, { transferId: _1.mkHash("0x456"), meta: { routingId: _1.mkHash("0x456") } });
                yield store.saveChannelState(transfer2Resolve.channel, transfer2Resolve.transfer);
                const channel2 = _1.mkAddress("0xbbb");
                const transfer3State = _1.createTestChannelState("create", {
                    channelAddress: channel2,
                    bob: _1.mkAddress("0xbaba"),
                    bobIdentifier: _1.mkPublicIdentifier("vectorABCD"),
                }, { transferId: _1.mkHash("0x789"), meta: { routingId: _1.mkHash("0x789") } });
                yield store.saveChannelState(transfer3State.channel, transfer3State.transfer);
                const channelFromStore = yield store.getChannelState(transfer1State.channel.channelAddress);
                _1.expect(channelFromStore).to.deep.eq(transfer2Resolve.channel);
                const transfersChannel1 = yield store.getActiveTransfers(transfer1State.channel.channelAddress);
                _1.expect(transfersChannel1.length).eq(1);
                const t1 = transfersChannel1.find((t) => t.transferId === transfer1State.transfer.transferId);
                _1.expect(t1).to.deep.eq(transfer1State.transfer);
                const transfersChannel2 = yield store.getActiveTransfers(transfer3State.channel.channelAddress);
                const t3 = transfersChannel2.find((t) => t.transferId === transfer3State.transfer.transferId);
                _1.expect(t3).to.deep.eq(transfer3State.transfer);
            }));
        });
        describe("getTransfers", () => {
            it("should work with and without filter", () => __awaiter(void 0, void 0, void 0, function* () {
                const channel1 = _1.mkAddress("0xaaa");
                const transfer1State = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                }, { transferId: _1.mkHash("0x123"), transferDefinition: _1.mkAddress("0xabc"), meta: { routingId: _1.mkHash("0x123") } });
                yield store.saveChannelState(transfer1State.channel, transfer1State.transfer);
                yield _1.delay(100);
                const firstDelay = new Date();
                yield _1.delay(100);
                const transfer2Create = _1.createTestChannelState("create", {
                    channelAddress: channel1,
                    nonce: transfer1State.channel.nonce + 1,
                }, { transferId: _1.mkHash("0x456"), meta: { routingId: _1.mkHash("0x456") } });
                yield store.saveChannelState(transfer2Create.channel, transfer2Create.transfer);
                const transfer2Resolve = _1.createTestChannelState("resolve", {
                    channelAddress: channel1,
                    nonce: transfer2Create.channel.nonce + 1,
                }, { transferId: _1.mkHash("0x456"), meta: { routingId: _1.mkHash("0x456") } });
                yield store.saveChannelState(transfer2Resolve.channel, transfer2Resolve.transfer);
                yield _1.delay(100);
                const secondDelay = new Date();
                yield _1.delay(100);
                const channel2 = _1.mkAddress("0xbbb");
                const transfer3State = _1.createTestChannelState("create", {
                    channelAddress: channel2,
                    bob: _1.mkAddress("0xbaba"),
                    bobIdentifier: _1.mkPublicIdentifier("vectorABCD"),
                }, { transferId: _1.mkHash("0x789"), meta: { routingId: _1.mkHash("0x789") } });
                yield store.saveChannelState(transfer3State.channel, transfer3State.transfer);
                const transfers = yield store.getTransfers();
                _1.expect(transfers.length).to.eq(3);
                _1.expect(transfers).to.deep.contain(transfer1State.transfer);
                _1.expect(transfers).to.deep.contain(Object.assign(Object.assign({}, transfer2Create.transfer), { transferResolver: transfer2Resolve.transfer.transferResolver }));
                _1.expect(transfers).to.deep.contain(transfer3State.transfer);
                const channelFiltered = yield store.getTransfers({ channelAddress: channel1 });
                _1.expect(channelFiltered.length).to.eq(2);
                _1.expect(channelFiltered).to.deep.contain(transfer1State.transfer);
                _1.expect(channelFiltered).to.deep.contain(Object.assign(Object.assign({}, transfer2Create.transfer), { transferResolver: transfer2Resolve.transfer.transferResolver }));
                const startDateFiltered = yield store.getTransfers({ startDate: secondDelay });
                _1.expect(startDateFiltered.length).to.eq(1);
                _1.expect(startDateFiltered).to.deep.contain(transfer3State.transfer);
                const endDateFiltered = yield store.getTransfers({ endDate: firstDelay });
                _1.expect(endDateFiltered.length).to.eq(1);
                _1.expect(endDateFiltered).to.deep.contain(transfer1State.transfer);
                const startAndEndDateFiltered = yield store.getTransfers({ startDate: firstDelay, endDate: secondDelay });
                _1.expect(startAndEndDateFiltered.length).to.eq(1);
                _1.expect(startAndEndDateFiltered).to.deep.contain(Object.assign(Object.assign({}, transfer2Create.transfer), { transferResolver: transfer2Resolve.transfer.transferResolver }));
                const definitionFiltered = yield store.getTransfers({
                    transferDefinition: transfer1State.transfer.transferDefinition,
                });
                _1.expect(definitionFiltered.length).to.be.eq(1);
                _1.expect(definitionFiltered[0]).to.be.deep.eq(transfer1State.transfer);
            }));
        });
        describe("getChannelStateByParticipants", () => {
            it("should work (regardless of order)", () => __awaiter(void 0, void 0, void 0, function* () {
                const channel = _1.createTestChannelState("deposit").channel;
                yield store.saveChannelState(channel);
                _1.expect(yield store.getChannelStateByParticipants(channel.aliceIdentifier, channel.bobIdentifier, channel.networkContext.chainId)).to.be.deep.eq(channel);
                _1.expect(yield store.getChannelStateByParticipants(channel.bobIdentifier, channel.aliceIdentifier, channel.networkContext.chainId)).to.be.deep.eq(channel);
            }));
        });
        describe("getTransferByRoutingId", () => {
            it("should work", () => __awaiter(void 0, void 0, void 0, function* () {
                const state = _1.createTestChannelState("create", {}, { meta: { routingId: _1.getRandomBytes32() } });
                yield store.saveChannelState(state.channel, state.transfer);
                _1.expect(yield store.getTransferByRoutingId(state.channel.channelAddress, state.transfer.meta.routingId)).to.be.deep.eq(state.transfer);
            }));
        });
        describe("getChannelStates", () => {
            it("should return all channel states", () => __awaiter(void 0, void 0, void 0, function* () {
                const c1 = _1.createTestChannelState("deposit", {
                    channelAddress: _1.mkAddress("0xccc1111"),
                    aliceIdentifier: _1.mkPublicIdentifier("vectorA"),
                    alice: _1.mkAddress("0xa"),
                }).channel;
                c1.latestUpdate.channelAddress = _1.mkAddress("0xccc1111");
                const c2 = _1.createTestChannelState("deposit", {
                    channelAddress: _1.mkAddress("0xccc2222"),
                    aliceIdentifier: _1.mkPublicIdentifier("vectorB"),
                    alice: _1.mkAddress("0xb"),
                }).channel;
                c2.latestUpdate.channelAddress = _1.mkAddress("0xccc2222");
                yield Promise.all([c1, c2].map((c) => {
                    return store.saveChannelState(c);
                }));
                const retrieved = yield store.getChannelStates();
                _1.expect(retrieved).to.be.deep.include(c1);
                _1.expect(retrieved).to.be.deep.include(c2);
                _1.expect(retrieved.length).to.be.eq(2);
            }));
        });
        describe("getWithdrawalCommitment / getWithdrawalCommitmentByTransactionHash / saveWithdrawalCommitment", () => {
            if (isBrowserStore) {
                const alice = _1.getRandomChannelSigner();
                const bob = _1.getRandomChannelSigner();
                const transferId = _1.getRandomBytes32();
                const commitment = {
                    channelAddress: _1.mkAddress("0xcc"),
                    amount: "10",
                    alice: alice.address,
                    bob: bob.address,
                    assetId: _1.mkAddress(),
                    aliceSignature: _1.mkSig("0xaaa"),
                    bobSignature: _1.mkSig("0xbbb"),
                    recipient: _1.mkAddress("0xrrr"),
                    nonce: "12",
                    callData: "0x",
                    callTo: _1.mkAddress(),
                    transactionHash: _1.mkHash("0xttt"),
                };
                beforeEach(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield store.saveWithdrawalCommitment(transferId, commitment);
                }));
                it("getWithdrawalCommitment should work", () => __awaiter(void 0, void 0, void 0, function* () {
                    _1.expect(yield store.getWithdrawalCommitment(transferId)).to.be.deep.eq(commitment);
                }));
                it("getWithdrawalCommitmentByTransactionHash should work", () => __awaiter(void 0, void 0, void 0, function* () {
                    _1.expect(yield store.getWithdrawalCommitmentByTransactionHash(commitment.transactionHash)).to.be.deep.eq(commitment);
                }));
            }
            else {
                let resolveUpdate;
                let createUpdate;
                const alice = _1.getRandomChannelSigner();
                const bob = _1.getRandomChannelSigner();
                const transferId = _1.getRandomBytes32();
                const commitment = {
                    channelAddress: _1.mkAddress("0xcc"),
                    amount: "10",
                    alice: alice.address,
                    bob: bob.address,
                    assetId: _1.mkAddress(),
                    aliceSignature: _1.mkSig("0xaaa"),
                    bobSignature: _1.mkSig("0xbbb"),
                    recipient: _1.mkAddress("0xrrr"),
                    nonce: "12",
                    callData: "0x",
                    callTo: _1.mkAddress(),
                    transactionHash: _1.mkHash("0xttt"),
                };
                beforeEach(() => __awaiter(void 0, void 0, void 0, function* () {
                    resolveUpdate = _1.createTestChannelUpdate(vector_types_1.UpdateType.resolve, {
                        channelAddress: commitment.channelAddress,
                        details: {
                            transferId,
                            transferResolver: { responderSignature: commitment.bobSignature },
                            meta: { transactionHash: commitment.transactionHash },
                        },
                        fromIdentifier: bob.publicIdentifier,
                        toIdentifier: alice.publicIdentifier,
                        assetId: commitment.assetId,
                        nonce: 5,
                    });
                    createUpdate = _1.createTestChannelUpdate(vector_types_1.UpdateType.create, {
                        channelAddress: commitment.channelAddress,
                        details: {
                            transferId,
                            balance: { amount: [commitment.amount, "0"], to: [commitment.recipient, bob.address] },
                            transferInitialState: {
                                initiatorSignature: commitment.aliceSignature,
                                initiator: commitment.alice,
                                responder: commitment.bob,
                                nonce: commitment.nonce,
                                callTo: commitment.callTo,
                                callData: commitment.callData,
                                fee: "0",
                            },
                        },
                        fromIdentifier: alice.publicIdentifier,
                        toIdentifier: bob.publicIdentifier,
                        assetId: commitment.assetId,
                        nonce: 4,
                    });
                    const { channel: createChannel, transfer } = _1.createTestChannelState(vector_types_1.UpdateType.create, {
                        channelAddress: commitment.channelAddress,
                        alice: commitment.alice,
                        bob: commitment.bob,
                        aliceIdentifier: alice.publicIdentifier,
                        bobIdentifier: bob.publicIdentifier,
                        latestUpdate: Object.assign({}, createUpdate),
                    });
                    yield store.saveChannelState(createChannel, Object.assign(Object.assign({}, transfer), { balance: createUpdate.balance }));
                    const resolveChannel = _1.createTestChannelState(vector_types_1.UpdateType.resolve, {
                        channelAddress: commitment.channelAddress,
                        alice: commitment.alice,
                        bob: commitment.bob,
                        aliceIdentifier: alice.publicIdentifier,
                        bobIdentifier: bob.publicIdentifier,
                        latestUpdate: Object.assign({}, resolveUpdate),
                    }).channel;
                    yield store.saveChannelState(Object.assign(Object.assign({}, resolveChannel), { latestUpdate: resolveUpdate }), Object.assign(Object.assign({}, transfer), { transferResolver: { responderSignature: commitment.bobSignature }, balance: createUpdate.balance }));
                    yield store.saveWithdrawalCommitment(transferId, commitment);
                }));
                it("should update transfer resolver", () => __awaiter(void 0, void 0, void 0, function* () {
                    const transferId = _1.mkBytes32("0xabcde");
                    const createState = _1.createTestChannelState("create", {}, { transferId });
                    yield store.saveChannelState(createState.channel, createState.transfer);
                    let transferFromStore = yield store.getTransferState(createState.transfer.transferId);
                    _1.expect(transferFromStore).to.deep.eq(Object.assign(Object.assign({}, createState.transfer), { transferState: Object.assign({ balance: createState.channel.latestUpdate.details.balance }, createState.transfer.transferState) }));
                }));
                it("should create an event subscription", () => __awaiter(void 0, void 0, void 0, function* () {
                    const pubId = _1.mkPublicIdentifier();
                    const subs = {
                        [vector_types_1.EngineEvents.CONDITIONAL_TRANSFER_CREATED]: "sub1",
                        [vector_types_1.EngineEvents.CONDITIONAL_TRANSFER_RESOLVED]: "sub2",
                        [vector_types_1.EngineEvents.DEPOSIT_RECONCILED]: "sub3",
                    };
                    const servernodestore = store;
                    yield servernodestore.registerSubscription(pubId, vector_types_1.EngineEvents.CONDITIONAL_TRANSFER_CREATED, "othersub");
                    const other = yield servernodestore.getSubscription(pubId, vector_types_1.EngineEvents.CONDITIONAL_TRANSFER_CREATED);
                    _1.expect(other).to.eq("othersub");
                    for (const [event, url] of Object.entries(subs)) {
                        yield servernodestore.registerSubscription(pubId, event, url);
                    }
                    const all = yield servernodestore.getSubscriptions(pubId);
                    _1.expect(all).to.deep.eq(subs);
                }));
            }
            it("should save transaction responses and receipts", () => __awaiter(void 0, void 0, void 0, function* () {
                const setupState = _1.createTestChannelState("setup").channel;
                yield store.saveChannelState(setupState);
                const response = _1.createTestTxResponse();
                yield store.saveTransactionResponse(setupState.channelAddress, vector_types_1.TransactionReason.depositA, response);
                const storedResponse = yield store.getTransactionByHash(response.hash);
                const { wait, confirmations, hash } = response, sanitizedResponse = __rest(response, ["wait", "confirmations", "hash"]);
                _1.expect(storedResponse).to.containSubset(Object.assign(Object.assign({}, sanitizedResponse), { status: vector_types_1.StoredTransactionStatus.submitted, channelAddress: setupState.channelAddress, transactionHash: hash, gasLimit: response.gasLimit.toString(), gasPrice: response.gasPrice.toString(), value: response.value.toString() }));
                const receipt = yield response.wait();
                yield store.saveTransactionReceipt(setupState.channelAddress, receipt);
                const storedReceipt = yield store.getTransactionByHash(response.hash);
                const { confirmations: receiptConfs } = receipt, sanitizedReceipt = __rest(receipt, ["confirmations"]);
                _1.expect(storedReceipt).to.containSubset(Object.assign(Object.assign(Object.assign({}, sanitizedResponse), sanitizedReceipt), { channelAddress: setupState.channelAddress, transactionHash: hash, gasLimit: response.gasLimit.toString(), gasPrice: response.gasPrice.toString(), value: response.value.toString(), cumulativeGasUsed: receipt.cumulativeGasUsed.toString(), gasUsed: receipt.gasUsed.toString(), status: vector_types_1.StoredTransactionStatus.mined }));
                const failed = _1.createTestTxResponse({ hash: _1.mkHash("0x13754"), nonce: 65 });
                yield store.saveTransactionResponse(setupState.channelAddress, vector_types_1.TransactionReason.depositB, failed);
                yield store.saveTransactionFailure(setupState.channelAddress, failed.hash, "failed to send");
                const { wait: fWait, confirmations: fConf, hash: fHash } = failed, sanitizedFailure = __rest(failed, ["wait", "confirmations", "hash"]);
                const storedFailure = yield store.getTransactionByHash(fHash);
                _1.expect(storedFailure).to.containSubset(Object.assign(Object.assign({}, sanitizedFailure), { transactionHash: fHash, gasLimit: failed.gasLimit.toString(), gasPrice: failed.gasPrice.toString(), value: failed.value.toString(), status: vector_types_1.StoredTransactionStatus.failed, error: "failed to send" }));
            }));
            it("should save and retrieve all update types and keep updating the channel", () => __awaiter(void 0, void 0, void 0, function* () {
                const setupState = _1.createTestChannelState("setup").channel;
                yield store.saveChannelState(setupState);
                let fromStore = yield store.getChannelState(setupState.channelAddress);
                _1.expect(fromStore).to.deep.eq(setupState);
                const updatedBalanceForDeposit = { amount: ["10", "20"], to: setupState.balances[0].to };
                const depositState = _1.createTestChannelState("deposit", {
                    nonce: setupState.nonce + 1,
                    defundNonces: setupState.defundNonces,
                    balances: [updatedBalanceForDeposit, setupState.balances[0]],
                    networkContext: setupState.networkContext,
                }).channel;
                yield store.saveChannelState(depositState);
                fromStore = yield store.getChannelState(setupState.channelAddress);
                _1.expect(fromStore).to.deep.eq(depositState);
                const createState = _1.createTestChannelState("create", {
                    channelAddress: setupState.channelAddress,
                    nonce: depositState.nonce + 1,
                    defundNonces: setupState.defundNonces,
                    networkContext: setupState.networkContext,
                }, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                yield store.saveChannelState(createState.channel, createState.transfer);
                fromStore = yield store.getChannelState(setupState.channelAddress);
                _1.expect(fromStore).to.deep.eq(createState.channel);
                const resolveState = _1.createTestChannelState("resolve", {
                    nonce: createState.channel.nonce + 1,
                    defundNonces: setupState.defundNonces,
                    networkContext: setupState.networkContext,
                }, {
                    transferId: _1.mkHash("0x111"),
                });
                yield store.saveChannelState(resolveState.channel, resolveState.transfer);
                fromStore = yield store.getChannelState(setupState.channelAddress);
                _1.expect(fromStore).to.deep.eq(resolveState.channel);
            }));
            it("should update transfer resolver", () => __awaiter(void 0, void 0, void 0, function* () {
                const transferId = _1.mkBytes32("0xabcde");
                const createState = _1.createTestChannelState("create", {}, { transferId });
                yield store.saveChannelState(createState.channel, createState.transfer);
                let transferFromStore = yield store.getTransferState(createState.transfer.transferId);
                _1.expect(transferFromStore).to.deep.eq(createState.transfer);
                const resolveState = _1.createTestChannelState("resolve", { nonce: createState.channel.nonce + 1 }, { transferId });
                yield store.saveChannelState(resolveState.channel, resolveState.transfer);
                const fromStore = yield store.getChannelState(resolveState.channel.channelAddress);
                _1.expect(fromStore).to.deep.eq(resolveState.channel);
                transferFromStore = yield store.getTransferState(resolveState.transfer.transferId);
                _1.expect(transferFromStore.transferResolver).to.deep.eq(resolveState.channel.latestUpdate.details.transferResolver);
            }));
            it("should create multiple active transfers", () => __awaiter(void 0, void 0, void 0, function* () {
                const createState = _1.createTestChannelState("create", {}, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                    balance: { to: [_1.mkAddress("0xaaa"), _1.mkAddress("0xbbb")], amount: ["5", "0"] },
                });
                yield store.saveChannelState(createState.channel, createState.transfer);
                const updatedState = _1.createTestChannelState("create", {
                    nonce: createState.channel.nonce + 1,
                }, {
                    transferId: _1.mkHash("0x112"),
                    meta: { routingId: _1.mkBytes32("0xeee") },
                    balance: { to: [_1.mkAddress("0xaaa"), _1.mkAddress("0xbbb")], amount: ["5", "0"] },
                });
                yield store.saveChannelState(updatedState.channel, updatedState.transfer);
                const channelFromStore = yield store.getChannelState(createState.channel.channelAddress);
                _1.expect(channelFromStore).to.deep.eq(updatedState.channel);
                const transfers = yield store.getActiveTransfers(createState.channel.channelAddress);
                _1.expect(transfers.length).eq(2);
                const t1 = transfers.find((t) => t.transferId === createState.transfer.transferId);
                const t2 = transfers.find((t) => t.transferId === updatedState.transfer.transferId);
                _1.expect(t1).to.deep.eq(createState.transfer);
                _1.expect(t2).to.deep.eq(updatedState.transfer);
            }));
            it("should get multiple transfers by routingId", () => __awaiter(void 0, void 0, void 0, function* () {
                const routingId = _1.mkBytes32("0xddd");
                const alice = _1.getRandomIdentifier();
                const bob1 = _1.getRandomIdentifier();
                const createState = _1.createTestChannelState("create", {
                    aliceIdentifier: alice,
                    alice: _1.getSignerAddressFromPublicIdentifier(alice),
                    bobIdentifier: bob1,
                    bob: _1.getSignerAddressFromPublicIdentifier(bob1),
                }, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId },
                    balance: {
                        to: [_1.getSignerAddressFromPublicIdentifier(alice), _1.getSignerAddressFromPublicIdentifier(bob1)],
                        amount: ["7", "0"],
                    },
                    responder: _1.getSignerAddressFromPublicIdentifier(alice),
                    initiator: _1.getSignerAddressFromPublicIdentifier(bob1),
                });
                yield store.saveChannelState(createState.channel, createState.transfer);
                const newBob = _1.getRandomIdentifier();
                const createState2 = _1.createTestChannelState("create", {
                    aliceIdentifier: alice,
                    alice: _1.getSignerAddressFromPublicIdentifier(alice),
                    channelAddress: _1.getRandomBytes32(),
                    bob: _1.getSignerAddressFromPublicIdentifier(newBob),
                    bobIdentifier: newBob,
                }, {
                    transferId: _1.mkHash("0x122"),
                    meta: { routingId },
                    balance: {
                        to: [_1.getSignerAddressFromPublicIdentifier(alice), _1.getSignerAddressFromPublicIdentifier(newBob)],
                        amount: ["7", "0"],
                    },
                    initiator: _1.getSignerAddressFromPublicIdentifier(alice),
                    responder: _1.getSignerAddressFromPublicIdentifier(newBob),
                });
                yield store.saveChannelState(createState2.channel, createState2.transfer);
                const transfers = yield store.getTransfersByRoutingId(routingId);
                _1.expect(transfers.length).to.eq(2);
                const t1 = transfers.find((t) => t.transferId === createState.transfer.transferId);
                const t2 = transfers.find((t) => t.transferId === createState2.transfer.transferId);
                _1.expect(t1).to.deep.eq(createState.transfer);
                _1.expect(t2).to.deep.eq(createState2.transfer);
            }));
        });
        describe("saveChannelDispute", () => {
            it("should work", () => __awaiter(void 0, void 0, void 0, function* () {
                const { channel, transfer } = _1.createTestChannelState("create", { nonce: 10 }, {
                    transferId: _1.mkHash("0x111"),
                    meta: { routingId: _1.mkBytes32("0xddd") },
                });
                yield store.saveChannelState(channel, transfer);
                yield store.saveChannelDispute(channel.channelAddress, {
                    channelStateHash: constants_1.HashZero,
                    consensusExpiry: "hello",
                    defundExpiry: "world",
                    merkleRoot: constants_1.HashZero,
                    nonce: "1",
                });
                const dispute = yield store.getChannelDispute(channel.channelAddress);
                console.log("dispute: ", dispute);
            }));
        });
    });
};
exports.testStore = testStore;
//# sourceMappingURL=testStore.js.map